import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import logo from "../../assets/logo.png";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

function ResetPasswordView({
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    error,
    success,
    handleSubmit
}) {
    const { t } = useTranslation();

    return (
        <div className="login-container">
            <LanguageSwitcher variant="auth" />

            <main className="login-box">
                <img
                    src={logo}
                    alt="Ferreira Systeembouw Logo"
                    className="login-logo"
                    loading="eager"
                />

                <h1 className="text-2xl font-bold text-center mb-4">
                    {t('resetPassword.title')}
                </h1>

                <form onSubmit={handleSubmit} className="login-form" noValidate>
                    <div className="form-group">
                        <label htmlFor="new-password-input" className="form-label">
                            {t('resetPassword.newPassword')}
                        </label>
                        <input
                            type="password"
                            id="new-password-input"
                            name="newPassword"
                            className="form-input"
                            placeholder={t('resetPassword.newPassword')}
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)}
                            required
                            aria-required="true"
                            aria-invalid={error ? "true" : "false"}
                            autoComplete="new-password"
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirm-password-input" className="form-label">
                            {t('resetPassword.confirmPassword')}
                        </label>
                        <input
                            type="password"
                            id="confirm-password-input"
                            name="confirmPassword"
                            className="form-input"
                            placeholder={t('resetPassword.confirmPassword')}
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            required
                            aria-required="true"
                            aria-invalid={error ? "true" : "false"}
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="form-actions">
                        <button
                            type="submit"
                            className="btn btn-submit w-full"
                            aria-label={t('resetPassword.reset')}
                        >
                            {t('resetPassword.reset')}
                        </button>
                    </div>
                </form>

                {success && (
                    <div className="success-message mt-4 p-3 rounded-md bg-success text-white" role="status" aria-live="polite">
                        {success}
                    </div>
                )}

                {error && (
                    <div className="error-message mt-4" role="alert" aria-live="polite">
                        {error}
                    </div>
                )}
            </main>
        </div>
    );
}

ResetPasswordView.propTypes = {
    newPassword: PropTypes.string.isRequired,
    setNewPassword: PropTypes.func.isRequired,
    confirmPassword: PropTypes.string.isRequired,
    setConfirmPassword: PropTypes.func.isRequired,
    error: PropTypes.string,
    success: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
};

export default ResetPasswordView;
